import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastService } from '../../common/toast.service';

export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
   const toastService = inject(ToastService);

  if (isPlatformBrowser(platformId)) {
    const token = localStorage.getItem('authToken');
    const role = atob(localStorage.getItem('userRole') || '');

    if (token) {
      // Redirect based on role
      if (role === 'admin') {
        router.navigateByUrl('/home', { replaceUrl: true }); // admin home
      } else if (role === 'user') {
        router.navigateByUrl('/user-home', { replaceUrl: true }); // user home
      } else {
       toastService.showToast('To visit this page you need to Login', 'success');
        router.navigateByUrl('', { replaceUrl: true }); // fallback
      }
      return false;
    }

    // User not logged in → allow access
    return true;
  }

  // On server-side, block access by default
  return false;
};
